<template>

  <standard-layout>
    <template v-slot:main>

      <q-page padding class="bg-blue-grey-1">

        <div class="row justify-center">
          <div class="col-12 col-xl-8 col-lg-10">

            <div class="row q-col-gutter-md">
              <div class="col-12 col-md-8">
                <slot></slot>
                <renters-insurance-card class="q-mt-md"></renters-insurance-card>
                <other-services class="gt-sm q-mt-md"></other-services>
              </div>
              <div class="col-12 col-md-4">
                <div class="q-gutter-y-md">
                  <selected-plan-card v-if="selected_plan" :plan="selected_plan" :usage="usage_selected"
                                      :show_edit="false"></selected-plan-card>
                  <your-info-card :first_name="first_name" :last_name="last_name" :email="email" :action="action"
                                  :spanish="spanish"
                                  :service_location_address="service_location?.label"
                                  :service_location_id="service_location?.esiid"
                                  :selected_start_date="selected_start_date" :show_edit="false"></your-info-card>
                  <need-help-card v-if="selected_plan" :plan="selected_plan"></need-help-card>
                </div>
              </div>
              <div class="col-12">
                <other-services class="lt-md"></other-services>
              </div>
            </div>
          </div>
        </div>

      </q-page>

    </template>


  </standard-layout>

</template>

<script>
import { defineComponent } from 'vue'
import SelectedPlanCard from "components/plans/cards/SelectedPlanCard";
import ServiceLocationCard from "components/service_location/ServiceLocationCard";
import ServiceStartDateCard from "components/service_start_date/ServiceStartDateCard";
import ProviderDetailsCard from "components/brand/ProviderDetailsCard";
import NeedHelpCard from "components/order/NeedHelpCard";
import Orders from "src/composables/Orders";
import Plans from "src/composables/Plans";
import StandardLayout from "layouts/StandardLayout";
import YourInfoCard from "components/order/YourInfoCard";
import { Cookies } from 'quasar'
import ServiceLocation from "src/composables/ServiceLocation";
import OtherServices from "components/order/OtherServices.vue";
import UsageFilters from "src/composables/UsageFilters";
import RentersInsuranceCard from "components/order/RentersInsuranceCard.vue";

export default defineComponent({
  name: 'OrderCompleteLayout',
  components: {
    RentersInsuranceCard,
    OtherServices,
    YourInfoCard,
    StandardLayout,
    NeedHelpCard,
    ProviderDetailsCard,
    ServiceStartDateCard,
    ServiceLocationCard,
    SelectedPlanCard
  },
  setup() {

    const { order } = Orders();
    const { plan_map } = Plans();
    const { map_service_location } = ServiceLocation();
    const { usage_selected } = UsageFilters()

    const { selected_plan, service_location, request } = order.value;
    selected_plan.value = plan_map(selected_plan.value);

    const order_date = order.value?.order_submit_response?.date_checked || order.value.last_modified_date
    Cookies.set('completed_order_id', order.value._id, { expires: 7 });
    Cookies.set('completed_order_date', order_date, { expires: 7 });

    return {
      selected_plan: selected_plan.value,
      service_location: map_service_location(service_location.value),
      action: request.options?.move_in ? 'Move' : request.selected_start_date ? 'Switch' : 'ASAP',
      selected_start_date: request.selected_start_date,
      spanish: request.options?.spanish,
      first_name: request.customer_information?.first_name,
      last_name: request.customer_information?.last_name,
      email: request.customer_information?.email,
      usage_selected
    }
  }
})
</script>

<style>
a {
  font-weight: bold;
  color: #29b6f6;
}

.q-stepper__content {
  display: none;
}
</style>
